import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTable, useSortBy, usePagination, useFilters, useGlobalFilter } from 'react-table'
import matchSorter from 'match-sorter'

import TableGroup from './TableGroup'
import Pagination from '../Pagination'
import EditVehicleModal from '../../Modal/EditVehicleModal'

// Define a default UI for filtering
const DefaultColumnFilter = ({
  column: { filterValue, preFilteredRows, setFilter }
}) => {
  const count = preFilteredRows.length

  return (
    <input
      value={filterValue || ''}
      onChange={e => {
        setFilter(e.target.value || undefined) // Set undefined to remove the filter entirely
      }}
      placeholder={`Search ${count} records...`}
    />
  )
}

const textFilter = (rows, id, filterValue) => {
  return matchSorter(rows, filterValue, { keys: [row => row.values[id]] })
}

// Let the table remove the filter if the string is empty
textFilter.autoRemove = val => !val

const Table = ({ columns, data }) => {
  const filterTypes = React.useMemo(
    () => ({
      // Add a new fuzzyTextFilterFn filter type.
      fuzzyText: textFilter,
      // Or, override the default text filter to use
      // "startWith"
      text: (rows, id, filterValue) => {
        return rows.filter(row => {
          const rowValue = row.values[id]
          return rowValue !== undefined
            ? String(rowValue)
              .toLowerCase()
              .startsWith(String(filterValue).toLowerCase())
            : true
        })
      }
    }), [])

  const defaultColumn = React.useMemo(
    () => ({
      // Let's set up our default Filter UI
      Filter: DefaultColumnFilter
    }), [])

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps, getTableBodyProps, headerGroups, page, prepareRow,
    state, visibleColumns, preGlobalFilteredRows, setGlobalFilter,
    canPreviousPage, canNextPage, pageOptions, pageCount, gotoPage, nextPage, previousPage, setPageSize, state: { pageIndex, pageSize }
  } = useTable({
    columns,
    data,
    initialState: { pageIndex: 0 },
    defaultColumn,
    filterTypes
  }, useFilters, useGlobalFilter,
  useSortBy, usePagination)

  const [editVehicleModalData, setEditVehicleModalData] = useState()

  const tableGroupProps = { getTableProps, getTableBodyProps, headerGroups, page, prepareRow }
  const filterProps = { state, visibleColumns, preGlobalFilteredRows, setGlobalFilter }
  const paginationProps = { canPreviousPage, canNextPage, pageOptions, pageCount, gotoPage, nextPage, previousPage, setPageSize, pageIndex, pageSize }

  const toggleEditVehicleModal = (data) => setEditVehicleModalData(data?.original)

  return (
    <>
      {editVehicleModalData ? <EditVehicleModal data={editVehicleModalData} onClose={toggleEditVehicleModal} /> : null}
      <TableGroup {...tableGroupProps} {...filterProps} onShowEditVehicleModal={toggleEditVehicleModal} />
      <Pagination {...paginationProps} />
    </>
  )
}

export default Table

Table.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array
}

DefaultColumnFilter.propTypes = {
  column: PropTypes.object,
  filterValue: PropTypes.string,
  preFilteredRows: PropTypes.array,
  setFilter: PropTypes.func
}
